import { useQueryParams } from 'hooks/useQueryParams';
import { useCallback } from 'react';

type HoursDrawerParams = {
  showHours?: string;
};

type UseHoursDrawerState = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const useHoursDrawerState = (): UseHoursDrawerState => {
  const [queryParams, setQueryParams] = useQueryParams<HoursDrawerParams>();

  const open = queryParams.showHours === 'true';

  const setOpen = useCallback(
    (isOpen: boolean) => {
      setQueryParams({
        ...queryParams,
        showHours: isOpen ? 'true' : undefined,
      });
    },
    [queryParams, setQueryParams],
  );

  return { open, setOpen };
};
